import {Injectable} from '@angular/core';

@Injectable()
export class UrlService {
    getBackendUrl(): string {
        const url: string = window.location.href;
        if (url.indexOf('localhost') > 0) {
            return 'http://localhost:8080/';
        }
        return url.split('#')[0];
    }
}
